interface IConfirmMessageConstants {
  ID_CONFIRM_MESSAGE_ELEMENT: string;
  ID_CONFIRM_MESSAGE_POSITIVE_BUTTON: string;
  ID_CONFIRM_MESSAGE_NEGATIVE_BUTTON: string;
  ID_CONFIRM_MESSAGE_STYLES_BLOCK: string;
}

export const constants: IConfirmMessageConstants = {
  ID_CONFIRM_MESSAGE_ELEMENT: 'sberlead_confirm_message_element__',
  ID_CONFIRM_MESSAGE_POSITIVE_BUTTON: 'sberlead_confirm_message_positive_button__',
  ID_CONFIRM_MESSAGE_NEGATIVE_BUTTON: 'sberlead_confirm_message_negative_button__',
  ID_CONFIRM_MESSAGE_STYLES_BLOCK: 'sberlead_confirm_message_styles_block__',
};